<style>
  #Coll {
    color: #fff;
    background-color: #800000;
    border-color: #ddd;
  }

  .hover-button {
    background-color: #d3d3d3;
    color: black;
    font-size: 14px;
    padding: 10px 20px;
  }

  .hover-button:hover {
    color: white;
    font-size: 16px;
    background-color: #800000;
  }

  #Shadow {
    box-shadow: 5px 6px 4px #888888;

  }
</style>
<div class="container-fluid">
  <div id="mainContent" class="container">
    <div class="container">
      <div style=" text-align:center; margin-top: 50px;">
        <h2>Management-Information-System: </h2>
      </div>
      <br>
      <div class="row col-md-12 m-0 p-1">
        <div class="col-sm-6">
          <div>
            <label class="col-form-label">Financial Year:<span class="text-danger">*</span></label>
          </div>
          <div>
            <select class="form-control form-control-sm" (change)="onFinancialYearSelect()" [(ngModel)]="fyId">
              <option value="null">Select Financial Year</option>
              <option *ngFor="let year of financialList" [value]="year.id">
                {{ year.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div>
            <label class="col-form-label">Select Quarter for MIS:<span class="text-danger">*</span></label>
          </div>
          <div>
            <select class="form-control form-control-sm" [(ngModel)]="selectedQuarter" (change)="getMisDetails()">
              <option value="">Select Quarter</option>
              <option *ngFor="let quarter of QuarterList" [value]="quarter.name">
                {{ quarter.name }}
              </option>
            </select>
            <!-- <select class="form-control form-control-sm" [(ngModel)]="newClient.frequency">
              <option value="">Select frequency</option>
              <option *ngFor="let frequency of FrequencyList" [value]="newClient.name">
                {{ frequency.name }}
              </option>
            </select> -->
          </div>
        </div>
        </div>
        <br>
      <div class="accordion" id="accordionExample">
        <div>
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left" type="button" id="Coll" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Financials
                </button>
              </h2>
            </div>
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body">
                <div id="checklistDiv">
                  <div class="">
                    <div class="row col-md-12 m-0 p-0" style="font-weight: bold; background-color: #647C90; color: white; ">
                      <div class="row col-md-12 m-0 p-0 border">
                        <div class="col-md-1 right-border" style="max-width: 5%; font-weight: bold; padding: 0px; ">Sr.No
                        </div>
                        <div class="col-md-5 right-border" >
                          Particulars
                        </div>
                        <div class="col-md-3 right-border">
                          Amount (Rs)
                        </div>
                        <div class="col-md-3">Remark</div>
                      </div>
                    </div>

                    <div class="row col-md-12 m-0 p-0">
                      <div class="row col-md-12 m-0 p-0"
                        *ngFor="let clist of mis.misDetails.financialsData; let i = index">
                        <div class="row col-md-12 m-0 p-0 border">
                          <div class="col-md-1 right-border"
                            style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                            {{ i + 1 }}
                          </div>
                          <div class="col-md-5 right-border" style="font-size: smaller; word-break: keep-all">
                            {{ clist.variable }}
                          </div>
                          <div class="col-md-3 right-border">
                            <input type="number" class="form-control form-control-xs" [disabled]="mis.status === 'Submitted'" [(ngModel)]="clist.amount"
                              (change)="calculateEndOfQuarter()" id="quantity" name="quantity" min="0"/>
                          </div>
                          <div class="col-md-3">
                            <input type="text" [(ngModel)]="clist.remark" [disabled]="mis.status === 'Submitted'" id="remark_{{ i }}" name="remark_{{ i }}"
                              class="form-control form-control-xs" [class.is-invalid]="
                                                                clist.remark?.required " matTooltip=""
                              matTooltipPosition="above" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Financials section end -->
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" id="Coll"
                  data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Business
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body">
                <div id="checklistDiv">
                  <div class="">
                    <div class="row col-md-12 m-0 p-0">
                      <div class="col-sm-8">
                        <div>
                          <label class=" col-form-label">New Client:<span class="text-danger">*</span></label>
                        </div>
                        <div>
                          <select  [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" 
                            (change)="onDropdownChange($event.target.value, 'newClientsDiv')" [(ngModel)]="newClientSelectValue" >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="addNewClientSection()"><i
                            class="fa fa-plus-square-o"  aria-hidden="true"></i>Add Section</button>
                      </div>
                    </div>
                    <div id="newClientsDiv">
                      <div class="row col-md-12 m-3 p-0 card"
                        *ngFor="let newClient of mis.misDetails.business.newClient; let i = index">
                        <div class="card-header" style="font-weight: bold; background-color: #647C90; color: white;">
                          New Client
                        </div>
                        <div class="row col-md-12 m-0 p-1 card-body ">
                          <div class="col-sm-5">
                            <div>
                              <label class=" col-form-label">Client Name:<span class="text-danger">*</span></label>
                            </div>
                            <div style="align-self: center; display: flex;">
                              <select class="form-control form-control-sm" [disabled]="mis.status === 'Submitted'" [(ngModel)]="newClient.clientId"   [required]="!newClient.clientId" (change)="getAssignmentFieldsForClient(i)">
                                <option value="null">Select Client</option>
                                <option *ngFor="let client of clientList" [value]="client.id">
                                  {{ client.name }}
                                </option>
                              </select>
                              <span *ngIf="!newClient.clientId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                            </div>
                          </div>
                          <div class="col-sm-5">
                            <div>
                              <label class=" col-form-label">Branch/Vertical:<span
                                  class="text-danger">*</span></label>
                            </div>
                            <div style="align-self: center; display: flex;">
                              <input type="text" [disabled]="mis.status === 'Submitted' || newClient.branch" class="form-control form-control-sm" [(ngModel)]="newClient.branch" [required]="!newClient.branch">
                              <span *ngIf="!newClient.branch" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                            </div>
                          </div>
                          
                          <div class="col-sm-2">
                            <div *ngIf="i!=0" style="margin-top: 30px;"><button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme"
                                (click)="removeNewClientSection(i)"><i class="fa fa-plus-square-o"
                                  aria-hidden="true"></i>Remove</button></div>
                          </div>

                        </div>
                        <div class="row col-md-12 m-0 p-1">
                         
                          <div class="col-sm-2">

                          </div>
                        </div>
                        <div class="row col-md-12 m-0 p-1">
                   
                          <div class="row col-md-12 m-0 p-1">
                         
                            <div class="col-sm-2">

                            </div>

                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div>
                                <label for="approversName" class="form-label">Date of creation of client on Elevate
                                  :<span class="text-danger">*</span>
                                </label>
                              </div>
                              <div class="input-group" style="align-self: center; display: flex;">
                                <input [disabled]="mis.status === 'Submitted' || newClient.clientCreationDate" class="form-control form-control-sm" placeholder="dd/mm/yyyy" name="creationDate"
                                  id="creationDate" ngbDatepicker #creationDate="ngbDatepicker" [placement]="'bottom'"
                                  [class.is-invalid]="" matTooltip="" matTooltipPosition="above"
                                  matTooltipClass="warn-tooltip" [(ngModel)]="newClient.clientCreationDate" [required]="!newClient.clientCreationDate" />
                                <div class="input-group-append">
                                  <button class="btn btn-outline-theme fa fa-calendar" (click)="creationDate.toggle()"
                                    type="button"></button>
                                </div>
                                <span *ngIf="!newClient.clientCreationDate" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                        
                            <div class="col-sm-2">

                            </div>

                          </div>
                          <div class="row col-md-12 m-0 p-1">
                           
                            <div class="col-sm-5">

                            </div>
                            <div class="col-sm-2">

                            </div>

                          </div>
                            <div class="row col-md-12 m-0 p-0 card">
                              <ng-container *ngFor="let assignment of newClient.assignments; let k = index"> 
                              <div class="card-header" style="font-weight: bold; background-color: #333333; color: white;">
                               Assignments
                              </div>
                           
                              <div class="row col-md-12 m-0 p-1 card-body ">
                                <div class="col-sm-5">
                                  <div>
                                    <label class=" col-form-label">Nature of Assignment:<span class="text-danger">*</span></label>
                                  </div>
                                  <div style="align-self: center; display: flex;">
                                        <select class="form-control form-control-sm" [disabled]="mis.status === 'Submitted' || assignment.assignmentId" 
                                          [(ngModel)]="assignment.assignmentId" [required]="!assignment.assignmentId">
                                          <option value="null">Select Assignment</option>
                                          <option *ngFor="let assignment of assignmentList" [value]="assignment.id">
                                            {{ assignment.name }}
                                          </option>
                                        </select>
                                      <span *ngIf="!assignment.assignmentId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                                  </div>
                                </div>
                                <div class="col-sm-5">
                                  <div>
                                    <label class="col-form-label">Fees:<span
                                        class="text-danger">*</span></label>
                                  </div>
                                  <div style="align-self: center; display: flex;">
                                    <input type="number" [disabled]="mis.status === 'Submitted' || assignment.fees" class="form-control form-control-sm" [(ngModel)]="assignment.fees" [required]="!assignment.fees">
                                    <span *ngIf="!assignment.fees" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div *ngIf="k!=0"><button class="btn btn-xs btn-theme"
                                      (click)="removeNewClientAssignmentsSection(i,k)"><i class="fa fa-plus-square-o"
                                        aria-hidden="true"></i>Remove</button></div>
                                  <!-- <div *ngIf="k==0">
                                          <button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="addNewClientAssignmentsSection(i)"><i
                                              class="fa fa-plus-square-o"  aria-hidden="true"></i>Add Section</button>
                                  </div> -->
                                  
                                </div>
    
                              </div>
                              <div class="row col-md-12 m-0 p-1 card-body " >
                                <div class="col-sm-5">
                                  <div>
                                    <label class=" col-form-label">Frequency:<span class="text-danger">*</span></label>
                                  </div>
                                  <div style="align-self: center; display: flex;">
                                    <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                      [(ngModel)]="assignment.frequency" [required]="!assignment.frequency">
                                      <option value="">Select Frequency</option>
                                      <option *ngFor="let frequency of FrequencyList" [value]="frequency.name">
                                        {{ frequency.name }}
                                      </option>
                                    </select>
                                    <span *ngIf="!assignment.frequency" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                                  </div>
                                </div>
                                <div class="col-sm-5">
                                  <div>
                                    <label class=" col-form-label">Incentive to:<span class="text-danger">*</span></label>
                                  </div>
                                  
                                  <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="assignment.incentiveTo" [required]="!assignment.incentiveTo">
                                  <option value="null">Select employee</option>
                                  <option *ngFor="let emp of incentiveToList" [value]="emp.id">
                                    {{ emp.firstName +' '+ emp.lastName }}
                                  </option>
                                </select>
                                </div>
                                <div class="col-sm-2">
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-1 card-body ">
                                <div class="col-sm-5">
                                  <div>
                                    <label class=" col-form-label">Budgeted contribution in %:<span
                                        class="text-danger">*</span></label>
                                  </div>
                                  <div style="align-self: center; display: flex;">
                                    <input type="number" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                      [(ngModel)]="assignment.budgetedContributionPercentage" [required]="!assignment.budgetedContributionPercentage">
                                      <span *ngIf="!assignment.budgetedContributionPercentage" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                                  </div>
                                </div>
                                <div class="col-sm-5">
                                  <div>
                                    <label for="approversName" class="form-label">Date of appointment :<span
                                        class="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div class="input-group" style="align-self: center; display: flex;">
                                    <input [disabled]="mis.status === 'Submitted'"  class="form-control form-control-sm" placeholder="dd/mm/yyyy"
                                      name="appointmentDate" id="appointmentDate" ngbDatepicker [required]="!assignment.appointmentDate || assignment.appointmentDate.year==null"
                                      #appointmentDate="ngbDatepicker" [placement]="'bottom'" [class.is-invalid]=""
                                      matTooltip="" matTooltipPosition="above" matTooltipClass="warn-tooltip"
                                      [(ngModel)]="assignment.appointmentDate" />
                                    <div class="input-group-append">
                                      <button class="btn btn-outline-theme fa fa-calendar"
                                        (click)="appointmentDate.toggle()" type="button"></button>
                                    </div>
                                    <span *ngIf="!assignment.appointmentDate || assignment.appointmentDate.year==null" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                                  </div>
                                </div>
                              </div>  
                              <div class="row col-md-12 m-0 p-1 card-body ">
                                <div class="col-sm-5">
                                  <div>
                                    <label for="approversName" class="form-label">NOC aplicable / not applicable :<span
                                        class="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div class="input-group" style="align-self: center; display: flex;">
                                        <select (change)="changeNocDate(i,k)" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" [(ngModel)]="assignment.NOCrequired">
                                          <option value="">Select</option>
                                          <option value="yes">Yes</option>
                                          <option value="no">No</option>
                                        </select>
                                  </div>
                                </div>
                                <div class="col-sm-5">
                                  <div>
                                    <label for="approversName" class="form-label">Date of NOC sent :<span
                                        class="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div class="input-group" style="align-self: center; display: flex;">
                                    <input [disabled]="mis.status === 'Submitted' || assignment.NOCrequired==='no'" class="form-control form-control-sm" placeholder="dd/mm/yyyy" name="DateOfNoc"
                                      id="DateOfNoc" ngbDatepicker #DateOfNoc="ngbDatepicker" [placement]="'bottom'"
                                      [class.is-invalid]="" matTooltip="" matTooltipPosition="above"
                                      matTooltipClass="warn-tooltip" [(ngModel)]="assignment.NOCrequired === 'no' ? {year: null, month: null, day: null} : assignment.dateOfNocSent"  [required]="!assignment.dateOfNocSent || assignment.dateOfNocSent.year==null && assignment.NOCrequired==='yes' "/>
                                    <div class="input-group-append">
                                      <button class="btn btn-outline-theme fa fa-calendar" (click)="DateOfNoc.toggle()"
                                        type="button"></button>
                                    </div>
                                    <span *ngIf="!assignment.dateOfNocSent || assignment.dateOfNocSent.year==null && assignment.NOCrequired==='yes'" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                                  </div>
                                </div>
                             
                              </div>
                              <div class="row col-md-12 m-0 p-1 card-body ">
                                <div class="col-sm-5">
                                  <div>
                                    <label for="approversName" class="form-label"> Whether EL prepared Yes/ no:<span
                                        class="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div class="input-group" style="align-self: center; display: flex;">
                                        <select (change)="changeEngagementLetterDate(i,k)"  [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" [(ngModel)]="assignment.ELrequired">
                                          <option value="">Select</option>
                                          <option value="yes">Yes</option>
                                          <option value="no">No</option>
                                        </select>
                                  </div>
                                </div>
                                <div class="col-sm-5">
                                  <div>
                                    <label for="approversName" class="form-label"> Engagement letter date :
                                      <span class="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div class="input-group" style="align-self: center; display: flex;">
                                    <input [disabled]="mis.status === 'Submitted' || assignment.ELrequired==='no'" class="form-control form-control-sm" placeholder="yyyy-MM-dd"
                                      name="engLetterDate" id="engLetterDate" ngbDatepicker #engLetterDate="ngbDatepicker"
                                      [placement]="'bottom'" [class.is-invalid]="" matTooltip="" matTooltipPosition="above"
                                      matTooltipClass="warn-tooltip" [(ngModel)]="assignment.ELrequired === 'no' ? {year: null, month: null, day: null} : assignment.engagementLetterDate" [required]="!assignment.engagementLetterDate || assignment.engagementLetterDate.year==null  && assignment.ELrequired==='yes'" />
                                    <div class="input-group-append">
                                      <button class="btn btn-outline-theme fa fa-calendar" (click)="engLetterDate.toggle()"
                                        type="button"></button>
                                    </div>
                                    <span *ngIf="!assignment.engagementLetterDate || assignment.engagementLetterDate.year==null && assignment.ELrequired==='yes'" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                                  </div>
                                </div>
                              </div>
                            </ng-container>  

                            </div>
                          
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div class="row col-md-12 m-0 p-0">
                        <div class="col-sm-8">
                          <div>
                            <label class=" col-form-label">New assignment with existing client:<span
                                class="text-danger">*</span></label>
                          </div>
                          <div>
                            <select  [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" [(ngModel)]="newAssignExistingClient"
                              (change)="onDropdownChange($event.target.value, 'newAssignExistClientsDiv')">
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="addNewAssignmentWithExistClient()"><i
                              class="fa fa-plus-square-o" aria-hidden="true"></i>Add Section</button>
                        </div>
                      </div>
                      <div id="newAssignExistClientsDiv">
                        <div class="row col-md-12 m-3 p-0 card"
                          *ngFor="let newAssignExistClient of mis.misDetails.business.newAssignmentForExistingClient; let i = index">
                          <div class="card-header" style="font-weight: bold; background-color: #647C90; color: white;">
                            New assignment with existing client:
                          </div>
                          <div class="row col-md-12 m-0 p-1 card-body ">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Client Name:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="newAssignExistClient.clientId" [required]="!newAssignExistClient.clientId">
                                  <option value="null">Select Client</option>
                                  <option *ngFor="let client of clientList" [value]="client.id">
                                    {{ client.name }}
                                  </option>
                                </select>
                                <span *ngIf="!newAssignExistClient.clientId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class="col-form-label">Nature of Assignment:<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="newAssignExistClient.assignmentId" [required]="!newAssignExistClient.assignmentId">
                                  <option value="null">Select Assignment</option>
                                  <option *ngFor="let assignment of assignmentList" [value]="assignment.id">
                                    {{ assignment.name }}
                                  </option>
                                </select>
                                <span *ngIf="!newAssignExistClient.assignmentId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div *ngIf="i!=0"><button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme"
                                  (click)="removeNewAssignmentWithExistClient(i)"><i class="fa fa-plus-square-o"
                                    aria-hidden="true"></i>Remove</button></div>
                            </div>

                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div>
                                <label class="col-form-label">Frequency:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="newAssignExistClient.frequency" [required]="!newAssignExistClient.frequency">
                                  <option value="">Select Frequency</option>
                                  <option *ngFor="let frequency of FrequencyList" [value]="frequency.name">
                                    {{ frequency.name }}
                                  </option>
                                </select>
                                <span *ngIf="!newAssignExistClient.frequency" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Fees:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="number" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="newAssignExistClient.fees" [required]="!newAssignExistClient.fees">
                                  <span *ngIf="!newAssignExistClient.fees" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                            <div class="col-sm-2">

                            </div>

                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Budgeted contribution in %:<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input  type="number" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="newAssignExistClient.budgetedContributionPercentage" [required]="!newAssignExistClient.budgetedContributionPercentage">
                                  <span *ngIf="!newAssignExistClient.budgetedContributionPercentage" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>  
                              </div>
                            </div>
                          
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div class="row col-md-12 m-0 p-0">
                        <div class="col-sm-8">
                          <div>
                            <label class=" col-form-label">Clients/assignment discontinued:<span
                                class="text-danger">*</span></label>
                          </div>
                          <div>
                            <select  [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" [(ngModel)]="clientAssignDiscontinued"
                              (change)="onDropdownChange($event.target.value, 'ClientAssignDiscontinuedDiv')">
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="addClientAssignmentDiscontinued()"><i
                              class="fa fa-plus-square-o" aria-hidden="true"></i>Add Section</button>
                        </div>
                      </div>
                      <div id="ClientAssignDiscontinuedDiv">
                        <div class="row col-md-12 m-3 p-0 card"
                          *ngFor="let clientAssignDiscontinued of mis.misDetails.business.clientsOrAssignmentDiscontinued; let i = index">
                          <div class="card-header" style="font-weight: bold; background-color: #647C90; color: white;">
                            Clients/assignment discontinued:
                          </div>
                          <div class="row col-md-12 m-0 p-1 card-body ">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Client Name:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="clientAssignDiscontinued.clientId" [required]="!clientAssignDiscontinued.clientId">
                                  <option value="null">Select Client</option>
                                  <option *ngFor="let client of discontinuedClientList" [value]="client.id">
                                    {{ client.name }}
                                  </option>
                                </select>
                                <span *ngIf="!clientAssignDiscontinued.clientId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class="col-form-label">Nature of Assignment:<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="clientAssignDiscontinued.assignmentId" [required]="!clientAssignDiscontinued.assignmentId">
                                  <option value="null">Select Assignment</option>
                                  <option *ngFor="let assignment of assignmentList" [value]="assignment.id">
                                    {{ assignment.name }}
                                  </option>
                                </select>
                                <span *ngIf="!clientAssignDiscontinued.assignmentId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div *ngIf="i!=0"><button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme"
                                  (click)="removeClientAssignmentDiscontinued(i)"><i class="fa fa-plus-square-o"
                                    aria-hidden="true"></i>Remove</button></div>
                            </div>

                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Fees:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="number" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="clientAssignDiscontinued.fees" [required]="!clientAssignDiscontinued.fees">
                                  <span *ngIf="!clientAssignDiscontinued.fees" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Reason:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="text" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="clientAssignDiscontinued.reason" [required]="!clientAssignDiscontinued.reason">
                                  <span *ngIf="!clientAssignDiscontinued.reason" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>  
                              </div>
                            </div>
                            <div class="col-sm-2">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div class="row col-md-12 m-0 p-0">
                        <div class="col-sm-8">
                          <div>
                            <label class=" col-form-label">Fees increased/decreased:<span
                                class="text-danger">*</span></label>
                          </div>
                          <div style="align-self: center; display: flex;">
                            <select  [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm " [(ngModel)]="feesIncreasedDecreased"
                              (change)="onDropdownChange($event.target.value, 'feesIncreasedDecreasedDiv')">
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="addFeesIncreasedOrDecreased()"><i
                              class="fa fa-plus-square-o" aria-hidden="true"></i>Add Section</button>
                        </div>
                      </div>
                      <div id="feesIncreasedDecreasedDiv">
                        <div class="row col-md-12 m-3 p-0 card"
                          *ngFor="let feesIncreasedDecreased of mis.misDetails.business.feesIncreasedOrDecreased; let i = index">
                          <div class="card-header" style="font-weight: bold; background-color: #647C90; color: white;">
                            Fees increased/decreased
                          </div>
                          <div class="row col-md-12 m-0 p-1 card-body ">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Client Name:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="feesIncreasedDecreased.clientId" [required]="!feesIncreasedDecreased.clientId">
                                  <option value="null">Select Client</option>
                                  <option *ngFor="let client of clientList" [value]="client.id">
                                    {{ client.name }}
                                  </option>
                                </select>
                                <span *ngIf="!feesIncreasedDecreased.clientId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>  
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class="col-form-label">Nature of Assignment:<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="feesIncreasedDecreased.assignmentId" [required]="!feesIncreasedDecreased.assignmentId">
                                  <option value="null">Select Assignment</option>
                                  <option *ngFor="let assignment of assignmentList" [value]="assignment.id">
                                    {{ assignment.name }}
                                  </option>
                                </select>
                                <span *ngIf="!feesIncreasedDecreased.assignmentId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>  
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div *ngIf="i!=0"><button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme"
                                  (click)="removeFeesIncreasedOrDecreased(i)"><i class="fa fa-plus-square-o"
                                    aria-hidden="true"></i>Remove</button></div>
                            </div>

                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Old Fees:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="number" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="feesIncreasedDecreased.oldFees" [required]="!feesIncreasedDecreased.oldFees">
                                  <span *ngIf="!feesIncreasedDecreased.oldFees" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">New Fees:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="number" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="feesIncreasedDecreased.newFees" [required]="!feesIncreasedDecreased.newFees">
                                  <span *ngIf="!feesIncreasedDecreased.newFees" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                              </div>
                            </div>
                            <div class="col-sm-2">
                            </div>
                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Remark :<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="text" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="feesIncreasedDecreased.remark" [required]="!feesIncreasedDecreased.remark">
                                  <span *ngIf="!feesIncreasedDecreased.remark" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div class="row col-md-12 m-0 p-0">
                        <div class="col-sm-8">
                          <div>
                            <label class=" col-form-label">Potential Client/Assignment:<span
                                class="text-danger">*</span></label>
                          </div>
                          <div style="align-self: center; display: flex;">
                            <select  [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" [(ngModel)]="potentialClientAssign"
                              (change)="onDropdownChange($event.target.value, 'potentialClientDiv')" >
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <button  class="btn btn-xs btn-theme" [disabled]="mis.status === 'Submitted'" (click)="addPotentialClientOrAssignment()"><i
                              class="fa fa-plus-square-o" aria-hidden="true"></i>Add Section</button>
                        </div>
                      </div>
                      <div id="potentialClientDiv">
                        <div class="row col-md-12 m-3 p-0 card"
                          *ngFor="let potentialClientAssign of mis.misDetails.business.potentialClientOrAssignment; let i = index">
                          <div class="card-header" style="font-weight: bold; background-color: #647C90; color: white;">
                            Potential Client/Assignment
                          </div>
                          <div class="row col-md-12 m-0 p-1 card-body ">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Client Name:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="text" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="potentialClientAssign.clientName" [required]="!potentialClientAssign.clientName">
                                  <span *ngIf="!potentialClientAssign.clientName" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class="col-form-label">Nature of Assignment:<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="potentialClientAssign.assignmentId" [required]="!potentialClientAssign.assignmentId">
                                  <option value="null">Select Assignment</option>
                                  <option *ngFor="let assignment of assignmentList" [value]="assignment.id">
                                    {{ assignment.name }}
                                  </option>
                                </select>
                                <span *ngIf="!potentialClientAssign.assignmentId" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div *ngIf="i!=0"><button class="btn btn-xs btn-theme"
                                  (click)="removePotentialClientOrAssignment(i)"><i class="fa fa-plus-square-o"
                                    aria-hidden="true"></i>Remove</button></div>
                            </div>

                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Frequency:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="potentialClientAssign.frequency" [required]="!potentialClientAssign.frequency">
                                  <option value="">Select Frequency</option>
                                  <option *ngFor="let frequency of FrequencyList" [value]="frequency.name">
                                    {{ frequency.name }}
                                  </option>
                                </select>
                                <span *ngIf="!potentialClientAssign.frequency" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div>
                                <label class=" col-form-label">Estimated Fees:<span class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="number" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="potentialClientAssign.fees" [required]="!potentialClientAssign.fees">
                                <span *ngIf="!potentialClientAssign.fees" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>    
                              </div>
                            </div>
                            <div class="col-sm-2">
                            </div>
                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div >
                                <label class=" col-form-label">Connect name (if any) :<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="text" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="potentialClientAssign.connectName" [required]="!potentialClientAssign.connectName">
                                  <span *ngIf="!potentialClientAssign.connectName" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>      
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div >
                                <label class=" col-form-label">Email 1:<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="text" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="potentialClientAssign.email1" [required]="!potentialClientAssign.email1">
                                  <span *ngIf="!potentialClientAssign.email1" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>      
                              </div>
                            </div>
                          </div>
                          <div class="row col-md-12 m-0 p-1">
                            <div class="col-sm-5">
                              <div >
                                <label class=" col-form-label">Email 2:<span
                                    class="text-danger">*</span></label>
                              </div>
                              <div style="align-self: center; display: flex;">
                                <input type="text" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                  [(ngModel)]="potentialClientAssign.email2" [required]="!potentialClientAssign.email2">
                                  <span *ngIf="!potentialClientAssign.email2" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>      
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Business Section -->
          <div class="card">
            <div class="card-header" id="headingThree" >
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left" type="button" id="Coll" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Engagement Performance
                </button>
              </h2>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div class="card-body">
                <div id="checklistDiv">
                  <div class="">
                    <div class="row col-md-12 m-0 p-0" style="font-weight: bold; background-color: #647C90; color: white;">
                      <div class="row col-md-12 m-0 p-0 border">
                        <div class="col-md-1 right-border" style="max-width: 5%; font-weight: bold; padding: 0px;">Sr.No
                        </div>
                        <div class="col-md-5 right-border" >
                          Others
                        </div>
                        <div class="col-md-3 right-border" >
                          Select from drop down
                        </div>
                        <div class="col-md-3" >Remark</div>
                      </div>
                    </div>

                    <div class="row col-md-12 m-0 p-0">
                      <div class="row col-md-12 m-0 p-0"
                        *ngFor="let clist of mis.misDetails.engagementPerformance; let i = index">
                        <div class="row col-md-12 m-0 p-0 border">
                          <div class="col-md-1 right-border"
                            style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                            {{ i + 1 }}
                          </div>
                          <div class="col-md-5 right-border" style="font-size: smaller; word-break: keep-all; align-self: center;" >
                            {{ clist.question }}
                          </div>
                          <div class="col-md-3 right-border" style="align-self: center;">
                            <select [disabled]="mis.status === 'Submitted'" (change)="detectRequiredValidation(clist)" class="form-control form-control-sm" [(ngModel)]="clist.answer">
                              <option value="">Select</option>
                              <option *ngFor="let frequency of engagementPerformanceList[i].dropdownList"
                                [value]="frequency.value">
                                {{ frequency.value }}
                              </option>
                            </select>
                            <!-- <select class="form-control form-control-sm">
                                                      <option value="">Select Role</option>
                                                      <option *ngFor="let frequency of clist.remark" [value]="frequency.value">
                                                        {{ frequency.value }}
                                                      </option>
                                                    </select> -->
                          </div>
                          <div class="col-md-3" style="align-self: center; display: flex;">
                              <input type="text" [disabled]="mis.status === 'Submitted'" [(ngModel)]="clist.remark" id="remark_{{ i }}" name="remark_{{ i }}"
                              class="form-control form-control-xs" [class.is-invalid]="
                                                          clist.remark?.required " matTooltip="" (change)="detectRequiredValidation(clist)"
                              matTooltipPosition="above" />
                              <span *ngIf="clist.required" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                            
                              
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Engagement Performance Section -->
          <div class="card">
            <div class="card-header" id="headingFour">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" id="Coll"
                  data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Financial Interests
                </button>
              </h2>
            </div>
            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
              <div class="card-body">
                <div id="checklistDiv">
                  <div class="">
                    <div class="row col-md-12 m-0 p-0">
                      <div class="col-sm-12">
                        <div id="checklistDiv">
                          <div class="">
                            <div class="row col-md-12 m-0 p-0" style="background-color: #647C90; color: white;">
                              <div class="row col-md-12 m-0 p-0 border ">
                                <div class="col-md-2 right-border"
                                  style="max-width: 5%; font-weight: bold; padding: 0px; ">Sr.No
                                </div>
                                <div class="col-md-4 right-border" >
                                  Particulars
                                </div>
                                <div class="col-md-6" style="font-weight: bold;">Comments</div>

                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                    1
                                  </div>
                                  <div class="col-md-4 right-border" style="font-weight: bold;padding: 0px">
                                    Loan Section
                                  </div>
                                  <div class="col-md-6">
                                    <div class="col-sm-12">
                                      <button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="addLoanSection()"><i
                                          class="fa fa-plus-square-o" aria-hidden="true"></i>Add Section</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0 border">
                                <div class="col-md-2 right-border"
                                  style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                </div>
                                <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">

                                </div>
                                <div class="col-md-6">
                                  <br>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0"
                              *ngFor="let financialInterests of mis.misDetails.financialInterests.loan; let i = index">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Name of Bank/NBFC
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="text" [disabled]="mis.status === 'Submitted'" id="" name="" [(ngModel)]="financialInterests.bank"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" />
                                      </div>
                                      <div class="col-md-3">
                                        <button *ngIf="i!=0" [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="removeLoanSection(i)"><i
                                            class="fa fa-plus-square-o" aria-hidden="true"></i> Remove</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Purpose of loan
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="text" [disabled]="mis.status === 'Submitted'" id="" name="" [(ngModel)]="financialInterests.loanPurpose"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Amount of Loan/balance
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" [disabled]="mis.status === 'Submitted'" id="" name="" [(ngModel)]="financialInterests.loanAmount"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Maturity Date
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9 input-group">
                                        <!-- <input type="text" [disabled]="mis.status === 'Submitted'" id="" name="" [(ngModel)]="financialInterests.maturityDate"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" /> -->
                                          <input [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" placeholder="dd/mm/yyyy" name="MaturityDate"
                                          id="MaturityDate" ngbDatepicker #MaturityDate="ngbDatepicker" [placement]="'bottom'"
                                          [class.is-invalid]="" matTooltip="" matTooltipPosition="above"
                                          matTooltipClass="warn-tooltip" [(ngModel)]="financialInterests.maturityDate" />
                                        <div class="input-group-append">
                                          <button class="btn btn-outline-theme fa fa-calendar" (click)="MaturityDate.toggle()"
                                            type="button"></button>
                                        </div>
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                  </div>
                                  <div class="col-md-6">
                                    <br>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                    2
                                  </div>
                                  <div class="col-md-4 right-border" style="font-weight: bold;padding: 0px;">
                                    Investments in Private Limited and securities other than shares in listed companies
                                  </div>
                                  <div class="col-md-6">
                                    <div class="col-sm-12">
                                      <button class="btn btn-xs btn-theme" [disabled]="mis.status === 'Submitted'" (click)="addPrivateInvestment()"><i
                                          class="fa fa-plus-square-o" aria-hidden="true"></i>Add Section</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0 border">
                                <div class="col-md-2 right-border"
                                  style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                </div>
                                <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">

                                </div>
                                <div class="col-md-6">
                                  <br>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0"
                              *ngFor="let privateInvestment of mis.misDetails.financialInterests.privateInvestment; let i = index">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Name of Company
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="text" id="" [disabled]="mis.status === 'Submitted'" name="" [(ngModel)]="privateInvestment.companyName"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" />
                                      </div>
                                      <div class="col-md-3">
                                        <button *ngIf="i!=0" class="btn btn-xs btn-theme" [disabled]="mis.status === 'Submitted'" (click)="removePrivateInvestment(i)"><i
                                            class="fa fa-plus-square-o" aria-hidden="true"></i> Remove</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Nature of investment
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="text" [disabled]="mis.status === 'Submitted'" id="" name=""
                                          [(ngModel)]="privateInvestment.investmentNature"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Number of shares
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" id="" [disabled]="mis.status === 'Submitted'" name="" [(ngModel)]="privateInvestment.sharesCount"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    Amount (Rs)
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" [disabled]="mis.status === 'Submitted'" id="" name="" [(ngModel)]="privateInvestment.amount"
                                          class="form-control form-control-xs" matTooltip=""
                                          matTooltipPosition="above" min="0" max="9" />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                  </div>
                                  <div class="col-md-6">
                                    <br>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- documents -->

                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                    3
                                  </div>
                                  <div class="col-md-4 right-border" style="font-weight: bold;padding: 0px;">
                                    Investments in Listed Companies- upload DEMAT statement
                                  </div>
                                  <div class="col-md-6" [ngClass]="{'disabled-icon': mis.status === 'Submitted'}">
                                    <div class="col-sm-12" style="margin-left: 40px; margin-top: 15px;">
                                      <div class="table-responsive">
                                        <table class="table table-bordered table-striped table-borderless">
                                          <thead>
                                            <tr>
                                              <th></th>
                                              <th></th>
                                              <th>Uploaded Documents</th>
                                              <th></th>
                                              <th></th>
                                            </tr>
                                          </thead>
                                          <!-- <ng-container>
                                            <tbody
                                              *ngFor="let subfolder of folderList.subFolder; let i = index"
                                            >
                                              <td width="5%" style="color: #800000!important">
                                                <i class="fa fa-folder fa-lg"></i>
                                              </td>
                                              <td width="35%" >
                                                <span style="color: #800000!important; cursor: pointer">{{
                                                  subfolder.name
                                                }}</span>
                                              </td>
                                              <td width="30%">
                                                {{ folderList.updatedDate | date: "dd-MMMM-yyyy" }}
                                              </td>
                                              <td width="10%"></td>
                                              <td width="10%"></td>
                                            </tbody>
                                          </ng-container> -->
                                          <ng-container *ngIf="mis.misDetails.financialInterests.documents">
                                            <tbody *ngFor="let document of mis.misDetails.financialInterests.documents; let i = index">
                                              <td>
                                                <i class="fa fa-file fa-2x"></i>
                                              </td>
                                              <td style="color: #800000!important">
                                                {{ document.fileName }}
                                              </td>
                                              <td>
                                                <!-- {{ document.updatedDate | date: "dd-MMMM-yyyy" }} -->
                                              </td>
                                              <td>
                                                <div>
                                                  <a 
                                                    style="color: #800000!important"
                                                    href="{{ document.url }}"
                                                    target="{{document.url}}"
                                                    ><i class="fa fa-download fa-lg"></i
                                                  ></a>
                                                </div>
                                              </td>
                                              <td>
                                                <i class="fa fa-trash fa-lg" aria-hidden="true" (click)="onDeleteDocument(i)" [ngClass]="{'disabled-icon': mis.status === 'Submitted'}"></i>
                                             </td>
                                            </tbody>
                                          </ng-container>
                                          
                                        </table>
                                        <p style="margin-left: 110px;" *ngIf="!mis.misDetails.financialInterests.documents">No Documents uploaded</p>
                                      </div>
                                    </div>
                                    <div class="col-sm-12">
                                      <div class="modal-body">

                                        <div class="filecontainer" appDnd (fileDropped)="onFileDropped($event);">
                                            <input type="file" #fileDropRef id="fileDropRef" multiple (change)="onFileSelected($event,'input')" />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
                                                <g fill="#3B454F" fill-rule="nonzero">
                                                    <path
                                                        d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                                                    <path
                                                        d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                                                    <path
                                                        d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
                                                </g>
                                            </svg>
                                        
                                            <h3>Drag and drop file here</h3>
                                            <h3>or</h3>
                                            <label for="fileDropRef">Browse for file</label>
                                        </div>
                                        <div class="files-list">
                                            <div class="single-file" *ngFor="let file of files; let i = index">
                                                <div class="file-icon" style="width: 50px">
                                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        x="0px" y="0px" viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;" xml:space="preserve">
                                                        <polygon style="fill:#EDEADA;" points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
                                                        <g>
                                                            <path style="fill:#CEC9AE;"
                                                                d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
                                                        </g>
                                                        <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
                                                    </svg>
                                                </div>
                                                <div class="info row">
                                                    <div class="col-md-6">
                                                        <h6 class="name">
                                                            {{ file?.fileName }}
                                                        </h6>
                                                    </div>
                                                    <!-- <div class="col-md-4">
                                                        <input type="text" id="displayFileName" name="displayFileName" class="form-control form-control-sm"
                                                        [(ngModel)]="file.displayFileName" placeholder="Display Name" style="font-size: 12px;">
                                                    </div> -->
                                                    <div class="col-md-4">
                                                        <p class="size">
                                                            {{ file?.fileSize}}
                                                        </p>
                                                    </div>
                                                    <!-- <div class="col-md-4">
                                                        <input type="text" id="description" name="description" class="form-control form-control-sm"
                                                        [(ngModel)]="file.description" placeholder="Enter Notes Here" style="font-size: 12px;">
                                                    </div>
                                                    <div class="col-md-2">
                                                    <input class="form-check-input form-checkbox" type="checkbox" name="isPrivate" id="isPrivate"
                                                      [(ngModel)]="file.isPrivate">
                                                    <label for="isPrivate">Is Private</label>
                                                    </div> -->
                                
                                                    
                                                    
                                                    <!-- <app-progress [progress]="file?.progress"></app-progress> -->
                                                </div>
                                        
                                                <div class="delete col-md-2" (click)="deleteFile(i)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                                                        <path fill="#B1B1B1" fill-rule="nonzero"
                                                            d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        
                                
                                    </div>
                                      
                                      <!-- <button class="btn btn-xs btn-theme" (click)="addPrivateInvestment()"><i class="fa fa-plus-square-o" aria-hidden="true" ></i>Add Section</button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0 border">
                                <div class="col-md-2 right-border"
                                  style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                </div>
                                <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">

                                </div>
                                <div class="col-md-6">
                                  <br>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Financial Interests Section -->
          <div class="card">
            <div class="card-header" id="headingFive">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" id="Coll"
                  data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  Material Issues
                </button>
              </h2>
            </div>
            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
              <div class="card-body">
                <div id="checklistDiv">
                  <div class="">
                    <div class="row col-md-12 m-0 p-0">
                      <div class="col-sm-12">
                        <div id="checklistDiv">
                          <div class="">
                            <div class="row col-md-12 m-0 p-0" style="font-weight: bold; background-color: #647C90; color: white;">
                              <div class="row col-md-12 m-0 p-0 border">
                                <div class="col-md-2 right-border"
                                  style="max-width: 5%; font-weight: bold; padding: 0px">Sr.No
                                </div>
                                <div class="col-md-4 right-border" style="font-weight: bold">
                                  Particulars
                                </div>
                                <div class="col-md-6" style="font-weight: bold">Comments</div>

                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                    1
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: keep-all">
                                    Have you come across any material issue relating to client or otherwise which you
                                    think is important to be discussed in all partners meeting
                                  </div>
                                  <div class="col-md-6" style="align-self: center;" >
                                    <select  [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                      (change)="onDropdownChange($event.target.value, 'materialIssuesDiv')" [(ngModel)]="materialIssuesSection">
                                      <option value="">Select</option>
                                      <option value="yes">Yes</option>
                                      <option value="no">No</option>
                                    </select>
                                    </div>
                                </div>
                                <div id="materialIssuesDiv" class="row col-md-12 m-0 p-1">
                                  <div class="row"  *ngFor="let materialIssues of mis.misDetails.materialIssues; let i = index">
                                  <div class="col-sm-5">
                                    <!-- <div>
                                      <label class=" col-form-label">Client Name:<span
                                          class="text-danger">*</span></label>
                                    </div>
                                    <div>
                                      <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="materialIssues.client">
                                    </div> -->
                                    <div>
                                      <label class=" col-form-label">Client Name:<span class="text-danger">*</span></label>
                                    </div>
                                    <div>
                                      <select [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm" [(ngModel)]="materialIssues.client" [required]="!materialIssues.client">
                                        <option value="null">Select Client</option>
                                        <option *ngFor="let client of clientList" [value]="client.id">
                                          {{ client.name }}
                                        </option>
                                      </select>
                                      <!-- <span *ngIf="!materialIssues.client" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span> -->
                                    </div>
                                  </div>
                                  <div class="col-sm-5">
                                    <div>
                                      <label class=" col-form-label">Description:<span
                                          class="text-danger">*</span></label>
                                    </div>
                                    <div>
                                      <input type="text" [disabled]="mis.status === 'Submitted'" class="form-control form-control-sm"
                                        [(ngModel)]="materialIssues.description"  [required]="!materialIssues.description">
                                        <!-- <span *ngIf="!materialIssues.description" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span> -->
                                    </div>
                                  </div>
                                  <div class="col-sm-2">
                                    <button *ngIf="i==0" [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme" (click)="addMaterialIssues()"><i
                                      class="fa fa-plus-square-o" aria-hidden="true"></i>Add Section</button>
                                      <div *ngIf="i!=0" style="margin-top: 30px;"><button [disabled]="mis.status === 'Submitted'" class="btn btn-xs btn-theme"
                                        (click)="removeMaterialIssues(i)"><i class="fa fa-plus-square-o"
                                          aria-hidden="true"></i>Remove</button></div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- End of Material Issues Section   -->
          <div class="card">
            <div class="card-header" id="headingSix">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left" type="button" id="Coll" data-toggle="collapse"
                  data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                  Independence
                </button>
              </h2>
            </div>
            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
              <div class="card-body">
                <div id="checklistDiv">
                  <div class="">
                    <div class="row col-md-12 m-0 p-0" style="font-weight: bold; background-color: #647C90; color: white;">
                      <div class="row col-md-12 m-0 p-0 border">
                        <div class="col-md-1 right-border" style="max-width: 5%; font-weight: bold; padding: 0px">Sr.No
                        </div>
                        <div class="col-md-5 right-border" style="font-weight: bold">
                          Others
                        </div>
                        <div class="col-md-3 right-border" style="font-weight: bold">
                          Select from drop down
                        </div>
                        <div class="col-md-3" style="font-weight: bold">Remark</div>
                      </div>
                    </div>

                    <div class="row col-md-12 m-0 p-0">
                      <div class="row col-md-12 m-0 p-0"
                        *ngFor="let clist of mis.misDetails.independence; let i = index">
                        <div class="row col-md-12 m-0 p-0 border">
                          <div class="col-md-1 right-border"
                            style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                            {{ i + 1 }}
                          </div>
                          <div class="col-md-5 right-border" style="font-size: smaller; word-break: keep-all">
                            {{ clist.question }}
                          </div>
                          <div class="col-md-3 right-border" style="align-self: center;">
                            <select [disabled]="mis.status === 'Submitted'" (change)="detectRequiredValidation(clist)" class="form-control form-control-sm" [(ngModel)]="clist.answer">
                              <option value="">Select</option>
                              <option *ngFor="let frequency of independenceList[i].dropdownList " [value]="frequency.value">
                                {{ frequency.value }}
                              </option>
                            </select>
                            <!-- <select class="form-control form-control-sm">
                                              <option value="">Select Role</option>
                                              <option *ngFor="let frequency of clist.remark" [value]="frequency.value">
                                                {{ frequency.value }}
                                              </option>
                                            </select> -->
                          </div>
                          <div class="col-md-3" style="align-self: center; display: flex;">
                            <input [disabled]="mis.status === 'Submitted'" (change)="detectRequiredValidation(clist)" type="text" [(ngModel)]="clist.remark" id="remark_{{ i }}" name="remark_{{ i }}"
                              class="form-control form-control-xs" [class.is-invalid]="
                                                  clist.remark?.required " matTooltip="" matTooltipPosition="above" />
                                                  <span *ngIf="clist.required" style="margin-left: 2px;"><i class="fa fa-lg fa-exclamation-circle" style="color: #df2d20;"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Independence section -->

          <div class="card">
            <div class="card-header" id="headingSeven">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" id="Coll"
                  data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false"
                  aria-controls="collapseSeven">
                  Training
                </button>
              </h2>
            </div>
            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
              <div class="card-body">
                <div id="checklistDiv">
                  <div class="">
                    <div class="row col-md-12 m-0 p-0">
                      <div class="col-sm-12">
                        <div id="checklistDiv">
                          <div class="">
                            <div class="row col-md-12 m-0 p-0" style="font-weight: bold; background-color: #647C90; color: white;">
                              <div class="row col-md-12 m-0 p-0 border">
                                <div class="col-md-2 right-border"
                                  style="max-width: 5%; font-weight: bold; padding: 0px">Sr.No
                                </div>
                                <div class="col-md-4 right-border" style="font-weight: bold">
                                  Particulars
                                </div>
                                <div class="col-md-6" style="font-weight: bold">Hours</div>

                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0 border">
                                <div class="col-md-2 right-border"
                                  style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                </div>
                                <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">

                                </div>
                                <div class="col-md-6">
                                  <br>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                    1
                                  </div>
                                  <div class="col-md-4 right-border" style="font-weight: bold;padding: 0px">
                                    Required
                                  </div>
                                  <div class="col-md-6">
                                    <div class="col-sm-12">
                                      <!-- <button class="btn btn-xs btn-theme"><i class="fa fa-plus-square-o" aria-hidden="true" ></i>Add Section</button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    PGB as presenter
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" id="" name=""  class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.requiredTraining.pgbPresenter"
                                          matTooltip="" matTooltipPosition="above" (change)="calculateTrainingSection()" disabled />
                                      </div>
                                      <div class="col-md-3">
                                        <!-- <button class="btn btn-xs btn-theme"><i class="fa fa-plus-square-o" aria-hidden="true"></i> Remove</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    PGB Internal
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" id="" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.requiredTraining.pgbInternal"
                                          matTooltip="" matTooltipPosition="above" (change)="calculateTrainingSection()" disabled />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    CPE
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" id="" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.requiredTraining.cpe" matTooltip=""
                                          matTooltipPosition="above" (change)="calculateTrainingSection()" disabled />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                  </div>
                                  <div class="col-md-6">
                                    <br>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                    2
                                  </div>
                                  <div class="col-md-4 right-border" style="font-weight: bold;padding: 0px">
                                    Actual completed
                                  </div>
                                  <div class="col-md-6">
                                    <div class="col-sm-12">
                                      <!-- <button class="btn btn-xs btn-theme"><i class="fa fa-plus-square-o" aria-hidden="true" ></i>Add Section</button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    PGB as presenter
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" [disabled]="mis.status === 'Submitted'" id="" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.actualTraining.pgbPresenter"
                                          matTooltip="" matTooltipPosition="above" (change)="calculateTrainingSection()"/>
                                      </div>
                                      <div class="col-md-3">
                                        <!-- <button class="btn btn-xs btn-theme"><i class="fa fa-plus-square-o" aria-hidden="true"></i> Remove</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    PGB Internal
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" [disabled]="mis.status === 'Submitted'" id="" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.actualTraining.pgbInternal" matTooltip=""
                                          matTooltipPosition="above" (change)="calculateTrainingSection()"/>
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    CPE
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" id="" [disabled]="mis.status === 'Submitted'" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.actualTraining.cpe" matTooltip=""
                                          matTooltipPosition="above" (change)="calculateTrainingSection()" />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                  </div>
                                  <div class="col-md-6">
                                    <br>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                    3
                                  </div>
                                  <div class="col-md-4 right-border" style="font-weight: bold;padding: 0px">
                                    Balance
                                  </div>
                                  <div class="col-md-6">
                                    <div class="col-sm-12">
                                      <!-- <button class="btn btn-xs btn-theme"><i class="fa fa-plus-square-o" aria-hidden="true" ></i>Add Section</button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row col-md-12 m-0 p-0">
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    PGB as presenter
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" [disabled]="mis.status === 'Submitted'" id="" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.balanceTraining.pgbPresenter"
                                          matTooltip="" matTooltipPosition="above" (change)="calculateTrainingSection()"/>
                                      </div>
                                      <div class="col-md-3">
                                        <!-- <button class="btn btn-xs btn-theme"><i class="fa fa-plus-square-o" aria-hidden="true"></i> Remove</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    PGB Internal
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" id="" [disabled]="mis.status === 'Submitted'" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.balanceTraining.pgbInternal"
                                          matTooltip="" matTooltipPosition="above" (change)="calculateTrainingSection()"/>
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                    CPE
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <input type="number" id="" [disabled]="mis.status === 'Submitted'" name="" class="form-control form-control-xs"
                                          [(ngModel)]="mis.misDetails.training.balanceTraining.cpe" matTooltip=""
                                          matTooltipPosition="above" (change)="calculateTrainingSection()" />
                                      </div>
                                      <div class="col-md-3">

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row col-md-12 m-0 p-0">
                                <div class="row col-md-12 m-0 p-0 border">
                                  <div class="col-md-2 right-border"
                                    style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                                  </div>
                                  <div class="col-md-4 right-border" style="font-size: smaller; word-break: break-all">
                                  </div>
                                  <div class="col-md-6">
                                    <br>
                                  </div>
                                </div>
                              </div>
                            </div>



                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 35px 0px 0px 450px;">
        <button (click)="saveMisForm()" [disabled]="mis.status === 'Submitted'" class="hover-button">Save</button>&nbsp;&nbsp;
        <button (click)="submitMisDetails()" [disabled]="mis.status === 'Submitted'" class="hover-button">Submit</button>
      </div>
    </div>
  </div>
</div>